import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit {

  @Input() index: any;
  @Input()
  element: any;
  @Input()
  isSubmitted: boolean = false;
  @Output() valueChanged = new EventEmitter();
  @Output() back = new EventEmitter<Boolean>(false);
  @Input() showBackButton: boolean = false;

  constructor(private _scrollToService: ScrollToService) { }

  ngOnInit() {
  }

  next() {
    this.valueChanged.emit(true);
    // const config: ScrollToConfigOptions = {
    //   target: 'destination' + (this.index + 1)
    // };
    // this._scrollToService.scrollTo(config)
  }

  backHandler() {
    this.back.emit(true);
  }

}
